<div class="form-group">
  <label *ngIf="label" for="codeThreshold">{{ label | translate }}</label>
  <input name="text" class="form-control" type="{{type}}" [(ngModel)]="text" (ngModelChange)="updateText()">
</div>